import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.boundShow = this.show.bind(this)
    this.boundHide = this.hide.bind(this)

    // turbo:click fires on actual link clicks before navigation
    document.addEventListener("turbo:click", this.boundShow)
    // Custom event for JS-based navigation (like company autocomplete)
    document.addEventListener("table-loading:show", this.boundShow)
    // Hide when new page renders
    document.addEventListener("turbo:render", this.boundHide)
    document.addEventListener("turbo:frame-render", this.boundHide)
  }

  disconnect() {
    document.removeEventListener("turbo:click", this.boundShow)
    document.removeEventListener("table-loading:show", this.boundShow)
    document.removeEventListener("turbo:render", this.boundHide)
    document.removeEventListener("turbo:frame-render", this.boundHide)
  }

  show() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }

  hide() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
  }
}
